// extracted by mini-css-extract-plugin
export default {"accordion":"permission_accordion__hz4s9","transparent":"permission_transparent__OUpIx","accordionheader":"permission_accordionheader__fynmA"};